import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { LensLineageSubplaceRouter, LensLineageSubplaceRouterProps } from './LensLineageSubplace';

export type EmbeddableLensSubplaceProps = VizPortalDataCatalogProviderProps & LensLineageSubplaceRouterProps;

export const EmbeddableLensSubplaceWithoutRouter: React.FC<EmbeddableLensSubplaceProps> = props => {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <LensLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
};
